
<template>
  <a-modal
    :title="title"
    :width="1400"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :footer="null"
    @cancel="handleCancel">

    <a-spin :spinning="confirmLoading">
      <div>
        <a-tabs v-model="tabIndex" @change="callback">
          <a-tab-pane tab="全部" key="0">
            <UserInviteAllTab v-if="hackRest" :userId="userId">
            </UserInviteAllTab>
          </a-tab-pane>
          <a-tab-pane tab="我的直推" key="1">
            <Tab1 v-if="hackRest" :userId="userId">
            </Tab1>
          </a-tab-pane>
          <a-tab-pane tab="我的间推" key="2">
            <UserInviteTab2 v-if="hackRest" :userId="userId">
            </UserInviteTab2>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
  import Tab1 from './UserTab1'
  import UserInviteAllTab from './UserInviteAllTab'
  import UserInviteTab2 from './UserInviteTab2'
  import UserTabUp from './UserTabUp'
  import Tab2 from './UserTab2'
  import Tab3 from './UserTab3'

  export default {
    name: "UserExtensionModal",
    components: {
      Tab1,
      UserInviteAllTab,
      UserInviteTab2,
      UserTabUp,
      Tab2,
      Tab3
    },
    data () {
      return {
        userId:"",
        loading: false,

        title:"操作",
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        validatorRules:{

        },
        url: {
        },
        tabIndex: '1',
        hackRest: false
      }
    },
    created () {
    },
    methods:{
      team(record) {
        this.userId = record.id;
        console.log("***********************************");
        console.log(this.userId);
        this.hackRest = false;
        this.$nextTick(() => {
          this.hackRest = true;
        });
        this.tabIndex = '0';
        this.visible = true;
      },
      handleCancel () {
        this.visible = false;
      },
      callback (key) {
        console.log(key);
        this.tabIndex = key;
      },
    },
  }
</script>